import React from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Contact from '../components/Contact';
import '../styles/HomePage.css'; // CSS-Import

const HomePage = () => {
  return (
    <>
      <Hero />
      <Services /> 
      <Portfolio />
      <Contact />
    </>
  );
};

export default HomePage;